import UUIDBase from '../UUIDBase'

export const customerPetI18nMessages = {
  en: {
    pets: 'Pets',
    addPet: 'Add a Pet',
    petName: 'Pet Name',
    dateOfBirth: 'DoB',
    type: 'Type',
    sex: 'Sex',
    breed: 'Breed',
    male: 'Male',
    female: 'Female',
    color: 'Color',
    neutered: 'Neutered?',
    petNameRequired: 'Pet name is required',
    petsNameRequired: 'Please enter a name for every pet'
  },
  ar: {
    pets: 'الحيوانات الأليفة',
    addPet: 'أضف أليف',
    petName: 'اسم الأليف',
    dateOfBirth: 'تاريخ الميلاد',
    type: 'النوع',
    sex: 'الجنس',
    breed: 'السلالة',
    male: 'ذكر',
    female: 'أنثى',
    color: 'اللون',
    neutered: 'معقم؟',
    petNameRequired: 'اسم الأليف مطلوب',
    petsNameRequired: 'يرجى إدخال اسم لكل حيوان أليف'
  }
}

export default class CustomerPet extends UUIDBase {
  static from(json: Record<string, unknown> | CustomerPet) {
    return Object.assign(new CustomerPet(), json)
  }

  name = ''
  dateOfBirth: Date | null = null
  type = ''
  sex = ''
  breed = ''
  color = ''
  neutered = false
  isDeleted = false
  customerId = ''
}
